import { createStore } from 'redux';
import counterReducer from './booking/bookingReducer';

const store = createStore(counterReducer);

export default store;
